import { Cancel, Create } from '@mui/icons-material';
import { MenuItem, Stack, SvgIcon, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { AssetProperty } from '../../../types';
import DraggableColumn from '../../sidebar/columns/DraggableColumn';
import assetTypes from '../../../../asset-details/data/asset_types.json';

const AssetPropertyDraggable: FunctionComponent<{
  item: AssetProperty;
  onEdit: (item: AssetProperty) => void;
  onRemove: (item: AssetProperty) => void;
  disabled?: boolean;
}> = ({ item, onEdit, onRemove, disabled }) => {
  const { id, asset, aggregation } = item;
  const assetTypeLabel = assetTypes.find((assetType) => assetType.value === asset.type)?.label;
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: 'none',
  };

  return (
    <div ref={setNodeRef} style={style}>
      <DraggableColumn
        id={id}
        disabled={disabled}
        dragHandleProps={disabled ? {} : { ...attributes, ...listeners }}
        renderContextItems={
          disabled
            ? undefined
            : () => (
                <>
                  <MenuItem onClick={() => onEdit(item)}>
                    <Stack alignItems="center" gap="2px" flexDirection="row">
                      <SvgIcon component={Create} />
                      <Typography variant="body2">Edit</Typography>
                    </Stack>
                  </MenuItem>
                  <MenuItem onClick={() => onRemove(item)}>
                    <Stack alignItems="center" gap="2px" flexDirection="row">
                      <SvgIcon color="error" component={Cancel} />
                      <Typography color="error" variant="body2">
                        Remove
                      </Typography>
                    </Stack>
                  </MenuItem>
                </>
              )
        }
      >
        <Typography variant="body2" fontWeight="600" color={disabled ? '#8998A0' : 'primary'}>
          {assetTypeLabel || asset.type} - {asset.property.label} - {aggregation.label}
        </Typography>
      </DraggableColumn>
    </div>
  );
};

export default AssetPropertyDraggable;
